import {Pagination} from '@store/common/pagination.model';
import {Container} from '@store/settings/containers/containers.model';
import {TableFilter, TableFilterType} from '@store/common/tableFilter.model';
import {OrganisationLight, OrganisationUnitLight} from '@store/common/organisation.model';
import I18n from '@utils/i18n.utils';
import {Waste, WasteFamily} from '@store/settings/wasteFamilies';

export interface ReportsFilters {
  search: string;
  from?: Date | null;
  to?: Date | null;
  //status?: GlobalStatus; 
  tableFilters: TableFilter[];
}

export enum ReportStatusEnum {
  CREATED = 'CREATED',
  ARCHIVED = 'ARCHIVED',
}

export namespace ReportStatusEnum {
  export const selectItems = () => [
    {label: I18n.t('global.reportStatusEnum.created'), value: ReportStatusEnum.CREATED},
    {label: I18n.t('global.reportStatusEnum.archived'), value: ReportStatusEnum.ARCHIVED},
  ].sort((a, b) => a.label.localeCompare(b.label));
}


export interface ReportsPagination extends Pagination {
  data: Report[];
}

export namespace ReportsFilters {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  export const initTableFilters = (clientId?: string) => TableFilterType.initTableFilters([
    TableFilterType.CLIENT_ORGANISATION,
    TableFilterType.CLIENT_ORGANISATION_UNIT,
    TableFilterType.WASTE_FAMILY,
    TableFilterType.WASTE,
    TableFilterType.SUPPLIER_ORGANISATION_UNIT,
    TableFilterType.CONTAINER,
  ]);
}

export namespace ManageReport {
  export const fromReport = (report: Report) => {
    return {
      ...report,
      // clientOrganisation: {id: report.organisation.id, name: report.organisation.name},
      // clientOrganisationUnit: {id: report.organisationUnits, name: report.clientOrganisationUnit.name},
      // supplierOrganisationUnit: {id: report.supplierOrganisationUnit, name: report.supplierOrganisationUnit.name},
      // wasteFamilies: report.wasteFamilies?.map((w) => ({id: w.id, name: w.name}),
      // wastes: report.wastes?.map((w) => ({id: w.id, name: w.name})),
      // containers: {id: report.container.id, name: report.container.name},
      // startDate: report.startDate ? new Date(report.startDate) : undefined,
      // endDate: report.endDate ? new Date(report.endDate) : undefined,
    };
  };

  export const toDto = (report: Report) => {
    return {
      from: report.startDate,
      to: report.endDate,
      clientOrganisationId: report.organisation.id,
      orgUnitIds: report.organisationUnits.map((ou) => ou.id),
      wasteIds: report.wastes.map((w) => w.id),
      //serviceKindIds: []
      //NOT STORED IN BE // USELESS FOR NOW
    };
  };

  export const fromTableFilter = (reports: TableFilter[], from?: Date | null, to?: Date | null) => {

    let orgUnitIds: any[] = [];
    let clientOrgId = 0;


    for (const report of reports) {
      if (report.type === 'SUPPLIER_ORGANISATION_UNIT') {
        orgUnitIds = [...orgUnitIds, ...report.values.map((v) => v.value)];
      }
      if (report.type === 'CLIENT_ORGANISATION_UNIT') {
        orgUnitIds = [...orgUnitIds, ...report.values.map((v) => v.value)];
      }
      if (report.type === 'CLIENT_ORGANISATION_UNIT') {
        orgUnitIds = [...orgUnitIds, ...report.values.map((v) => v.value)];
      }

      if (report.type === 'CLIENT_ORGANISATION') {
        if (report.values[0])
          clientOrgId = report.values[0].value;
      }

    }
    return {
      from: from,
      to: to,
      clientOrganisationId: clientOrgId,
      orgUnitIds: orgUnitIds.join(','),
    };
  };
}

export interface ReportUI {
  id: number;
  selected: boolean;
}


export interface Report {
  id: number;
  startDate: Date;
  endDate: Date;
  status: ReportStatusEnum;
  organisation: OrganisationLight;
  organisationUnits: OrganisationUnitLight[]; //client
  supplierOrganisationUnit: OrganisationUnitLight;
  wasteFamilies: WasteFamily[];
  wastes: Waste[];
  containers: Container[];
  author: string;
}
